import { ControllerRenderProps, Select } from '@otp/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IssueTicketStatus } from 'src/graphql/generated/graphql';

type StatusProps = {
  field: ControllerRenderProps<any, 'status'>;
  hasError: boolean;
  className?: string;
};

export const StatusField = ({ field, hasError, className }: StatusProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.form.fields.status-options',
  });

  const statusOptions = useMemo(
    () => [
      { value: IssueTicketStatus.Open, name: t('open') },
      { value: IssueTicketStatus.InProgress, name: t('in-progress') },
      { value: IssueTicketStatus.Blocked, name: t('blocked') },
      { value: IssueTicketStatus.Resolved, name: t('resolved') },
    ],
    [t],
  );

  const defaultStatusValue = field.value;

  return (
    <Select
      key={field.value}
      fullWidth={true}
      className={className}
      options={statusOptions}
      placeholder={t('placeholder')}
      defaultValue={defaultStatusValue}
      error={hasError}
      {...field}
      value={undefined}
      ref={undefined}
      inputRef={field.ref}
    />
  );
};
